'use client'

import { CheckCircle } from 'lucide-react'
import Link from 'next/link'

import { Button } from '@/components/ui/button'

export function SuccessStep() {
  return (
    <div className="space-y-6 text-center">
      <CheckCircle className="mx-auto h-16 w-16 text-green-500" />
      <div className="space-y-2">
        <h3 className="text-xl font-semibold text-gray-900">Password Reset Successfully!</h3>
        <p className="text-gray-600">Your password has been updated. You can now log in with your new password.</p>
      </div>
      <Link href="/login">
        <Button className="w-full bg-blue-600 text-white hover:bg-blue-700">Back to Login</Button>
      </Link>
    </div>
  )
}
